import { User } from '@auth0/auth0-react';
import { useLDClient } from '@mikecousins/launchdarkly-react-client-sdk';
import { useEffect } from 'react';

export const useLaunchDarkly = (user: User | undefined) => {
  const ldClient = useLDClient();

  useEffect(() => {
    if (user && ldClient) {
      ldClient.identify({
        key: user.sub,
        kind: 'user',
        custom: {
          name: user.name,
          email: user.email,
        },
      });
    }
  }, [ldClient, user]);

  useEffect(() => {
    if (!ldClient) return;

    // The streaming connection is the dominant source of reconnect noise from idle tabs.
    const handleVisibilityChange = () => {
      ldClient.setStreaming(document.visibilityState === 'visible');
    };

    // Sync immediately in case the client initialises into an already-backgrounded tab
    // (e.g. opened via middle-click, or restored by the browser) rather than waiting for
    // the first visibilitychange event.
    handleVisibilityChange();

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [ldClient]);

  return ldClient;
};
